import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWallet5: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconWallet5"><Path d="M19.5 4C20.8807 4 22 5.11929 22 6.5V9H17C15.8954 9 15 9.89543 15 11V13C15 14.1046 15.8954 15 17 15H22V17.5C22 18.8807 20.8807 20 19.5 20H4.5C3.11929 20 2 18.8807 2 17.5V6.5C2 5.11929 3.11929 4 4.5 4H19.5Z" fill="currentColor"/><Path d="M16 11C16 10.4477 16.4477 10 17 10H22C22.5523 10 23 10.4477 23 11V13C23 13.5523 22.5523 14 22 14H17C16.4477 14 16 13.5523 16 13V11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconWallet5;
